export default "__VITE_ASSET__D1zF44BV__"